module.exports = "/static/js/90f576919346350bc3e9e932dc9e0cb6.png";